var map = {
	"./icons/PlatTLogo.svg": 95177,
	"./icons/access-time-filled.svg": 18284,
	"./icons/add-filled.svg": 57411,
	"./icons/arrow-down.svg": 24746,
	"./icons/arrow-left.svg": 81833,
	"./icons/arrow-right.svg": 80153,
	"./icons/bx-seach.svg": 56183,
	"./icons/bx-x.svg": 23394,
	"./icons/checkmark.svg": 63538,
	"./icons/chevron-down.svg": 51728,
	"./icons/chevron-up.svg": 87072,
	"./icons/documentsLogo.svg": 56930,
	"./icons/dot.svg": 2583,
	"./icons/envelope-password-fill.svg": 95687,
	"./icons/fbook-grey.svg": 47783,
	"./icons/fbook.svg": 97989,
	"./icons/flag_en_GB.svg": 3822,
	"./icons/flag_pl.svg": 33091,
	"./icons/flaga_ru.svg": 94873,
	"./icons/instagram-grey.svg": 51878,
	"./icons/instagram.svg": 60673,
	"./icons/linkedIn-grey.svg": 17622,
	"./icons/linkedIn.svg": 91635,
	"./icons/lock-password-fill.svg": 68556,
	"./icons/logo.svg": 83190,
	"./icons/menu.svg": 85674,
	"./icons/sharp-account-circle.svg": 48945,
	"./icons/textLogo.svg": 90318,
	"./icons/tick-circle-solid.svg": 59579,
	"./icons/user.svg": 51816,
	"./icons/usergroup-outlined.svg": 79688,
	"./icons/ytube-grey.svg": 40083,
	"./icons/ytube.svg": 10788,
	"./images/ADMA-methdology.png": 76492,
	"./images/PlatT-methodology.jpg": 47686,
	"./images/analytics-mock.png": 94548,
	"./images/eu-logos.jpg": 730,
	"./images/example.png": 22576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;